import oneOneSchema from "./oneOneSchema";
import oneTwoSchema from "./oneTwoSchema";
import oneThreeSchema from "./oneThreeSchema";
import oneFourSchema from "./oneFourSchema";
import oneFiveSchema from "./oneFiveSchema";
import twoOneSchema from "./twoOneSchema";
import twoTwoSchema from "./twoTwoSchema";
import twoThreeSchema from "./twoThreeSchema";
import twoFourSchema from "./twoFourSchema";
import threeFourSchema from "./threeFourSchema";
import threeSixSchema from "./threeSixSchema";
import threeSevenSchema from "./threeSevenSchema";
import threeNineSchema from "./threeNineSchema";
import threeOneSchema from "./threeOneSchema";
import threeTwoSchema from "./threeTwoSchema";
import threeThreeSchema from "./threeThreeSchema";
import threeFiveSchema from "./threeFiveSchema";
import threeEightSchema from "./threeEightSchema";
import threeTenSchema from "./threeTenSchema";
import threeElevenSchema from "./threeElevenSchema";
import threeTwelveSchema from "./threeTwelveSchema";
import threeThirteenSchema from "./threeThirteenSchema";
import threeFourteenSchema from "./threeFourteenSchema";
import threeFifteenSchema from "./threeFifteenSchema";

export const GHGEASchemas = {
  "1.1 Direct Emissions from Stationary Combustion": oneOneSchema,
  "1.2 Direct Emissions from Mobile Combustion": oneTwoSchema,
  "1.3 Direct Emissions from Process Sources": oneThreeSchema,
  "1.4 Direct Emissions from Fugitive Sources": oneFourSchema,
  "1.5 Direct Emissions from Agricultural Sources": oneFiveSchema,
  "2.1 Indirect Emissions from Purchased/Acquired Electricity": twoOneSchema,
  "2.2 Indirect Emissions from Purchased/Acquired Steam": twoTwoSchema,
  "2.3 Indirect Emissions from Purchased/Acquired Heating": twoThreeSchema,
  "2.4 Indirect Emissions from Purchased/Acquired Cooling": twoFourSchema,
  "3.4 Upstream Transportation and Distribution": threeFourSchema,
  "3.6 Business Travel": threeSixSchema,
  "3.7 Employee Commuting": threeSevenSchema,
  "3.9 Downstream Transportation and Distribution": threeNineSchema,
  "3.1 Purchased Goods and Services": threeOneSchema,
  "3.2 Capital Goods": threeTwoSchema,
  "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)": threeThreeSchema,
  "3.5 Waste Generated in Operations": threeFiveSchema,
  "3.8 Upstream Leased Assets": threeEightSchema,
  "3.10 Processing of Solid Products": threeTenSchema,
  "3.11 Use of Solid Products": threeElevenSchema,
  "3.12 End-of-Life Treatment of Solid Products": threeTwelveSchema,
  "3.13 Downstream Leased Assets": threeThirteenSchema,
  "3.14 Franchise (Scope 1 and Scope 2)": threeFourteenSchema,
  "3.15 Investments": threeFifteenSchema,
};
